/**
 * Environment utilities
 * Centralizes environment detection and configuration
 */

export const isDevelopment = import.meta.env.DEV;
export const isProduction = import.meta.env.PROD;
export const isTest = import.meta.env.MODE === 'test';

// Legacy export for compatibility
export const isDev = isDevelopment;
